import { Point } from "./Point";
import { Utils } from "../utils/Utils";
export class GrahamScan {
    static _getPoints(count, tempUse = false, rst = null) {
        while (_mPointList.length < count)
            _mPointList.push(new Point());
        if (!rst)
            rst = [];
        rst.length = 0;
        if (tempUse) {
            GrahamScan.getFrom(rst, _mPointList, count);
        }
        else {
            GrahamScan.getFromR(rst, _mPointList, count);
        }
        return rst;
    }
    static getFrom(rst, src, count) {
        var i;
        for (i = 0; i < count; i++) {
            rst.push(src[i]);
        }
        return rst;
    }
    static getFromR(rst, src, count) {
        var i;
        for (i = 0; i < count; i++) {
            rst.push(src.pop());
        }
        return rst;
    }
    static pListToPointList(pList, tempUse) {
        var i, len = pList.length / 2, rst = GrahamScan._getPoints(len, tempUse, _tempPointList);
        for (i = 0; i < len; i++) {
            rst[i].setTo(pList[i + i], pList[i + i + 1]);
        }
        return rst;
    }
    static pointListToPlist(pointList) {
        var i, len = pointList.length, rst = _temPList, tPoint;
        rst.length = 0;
        for (i = 0; i < len; i++) {
            tPoint = pointList[i];
            rst.push(tPoint.x, tPoint.y);
        }
        return rst;
    }
    static scanPList(pList) {
        Utils.copyArray(pList, GrahamScan.pointListToPlist(GrahamScan.scan(GrahamScan.pListToPointList(pList, true))));
    }
    static scan(PointSet) {
        let i, j, k = 0, top = 2;
        let n = PointSet.length;
        let _tmpDic = {};
        let ch = _temArr;
        ch.length = 0;
        n = PointSet.length;
        for (i = n - 1; i >= 0; i--) {
            let tmp = PointSet[i];
            let key = tmp.x + "_" + tmp.y;
            if (!(key in _tmpDic)) {
                _tmpDic[key] = true;
                ch.push(tmp);
            }
        }
        n = ch.length;
        Utils.copyArray(PointSet, ch);
        for (i = 1; i < n; i++) {
            if ((PointSet[i].y < PointSet[k].y) || ((PointSet[i].y == PointSet[k].y) && (PointSet[i].x < PointSet[k].x)))
                k = i;
        }
        let tmp = PointSet[0];
        PointSet[0] = PointSet[k];
        PointSet[k] = tmp;
        for (i = 1; i < n - 1; i++) {
            k = i;
            for (j = i + 1; j < n; j++) {
                if ((multiply(PointSet[j], PointSet[k], PointSet[0]) > 0) || ((multiply(PointSet[j], PointSet[k], PointSet[0]) == 0) && (dis(PointSet[0], PointSet[j]) < dis(PointSet[0], PointSet[k]))))
                    k = j;
            }
            let tmp = PointSet[i];
            PointSet[i] = PointSet[k];
            PointSet[k] = tmp;
        }
        ch.length = 0;
        if (PointSet.length < 3) {
            return Utils.copyArray(ch, PointSet);
        }
        ch.push(PointSet[0], PointSet[1], PointSet[2]);
        for (i = 3; i < n; i++) {
            while (ch.length >= 2 && multiply(PointSet[i], ch[ch.length - 1], ch[ch.length - 2]) >= 0)
                ch.pop();
            PointSet[i] && ch.push(PointSet[i]);
        }
        return ch;
    }
}
const _mPointList = [];
const _tempPointList = [];
const _temPList = [];
const _temArr = [];
function multiply(p1, p2, p0) {
    return ((p1.x - p0.x) * (p2.y - p0.y) - (p2.x - p0.x) * (p1.y - p0.y));
}
function dis(p1, p2) {
    return (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y);
}
